<template>
  <Page key="Result" :query-api="queryApi" page-type="result" />
</template>
<script>
import { purchaseApi } from '@/api';
import Page from '../components/commonPage.vue';
export default {
  name: 'BusinessPurchaseEntryResult',
  components: {
    Page,
  },
  data() {
    return {
      queryApi: purchaseApi.getStockinResults,
    };
  },
};
</script>
